import Vue from "vue";
import moment from "moment";
import { definePlugin } from "./plugin";

export const MomentPlugin = definePlugin(() => {
  moment.locale("ru");
});

export default Vue.prototype.$moment = moment;
